import classNames from 'classnames';
import { Button } from '@get-mosh/msh-shared';
import styles from './sticky-button.module.scss';

export interface StickyButtonProps {
    className?: string;
    text: string;
    onClick?: () => void;
    link: string;
}

export const handleStickyVisibility = (visibility: string) => {
    document.body.setAttribute(
        'data-sticky-button-show',
        visibility === 'show' ? 'true' : 'false',
    );
};

const StickyButton = (props: StickyButtonProps) => {
    return (
        <div className={classNames(props.className, styles['wrapper'])}>
            <Button
                as="a"
                className={styles['button']}
                href={props.link}
                text={props.text}
                onClick={props.onClick}
            />
        </div>
    );
};

export default StickyButton;
